export const RESPONSE_MESSAGES = {
  RESPONSE_RESEND_OTP_SUCCESS: 'Resent OTP successfully',
  RESPONSE_SIGNUP_SUCCESS: 'Customer Successfully Signed up',
};
